import { createWritableGenericContext } from '@luna/context';

type CustomizationFeature = 'color' | 'alias' | 'avatar';

type ActiveCustomizationFeature = {
    resetActiveCustomization: () => void;
} & CustomizationFeatureProps;

export type CustomizationFeatureProps = {
    [feature in Capitalize<CustomizationFeature> as `activate${feature}ChangeCustomization`]: () => void;
} & {
    [feature in Capitalize<CustomizationFeature> as `is${feature}ChangeCustomizationActive`]: boolean;
};

const activeCustomizationFeatureContext = createWritableGenericContext<
    CustomizationFeature | undefined
>('active-customization-feature');

export const ActiveCustomizationFeatureProvider =
    activeCustomizationFeatureContext.createContextProvider(undefined).Provider;

export const useActiveCustomizationFeature = (): ActiveCustomizationFeature => {
    const { setValue, value } = activeCustomizationFeatureContext.useContext();

    return {
        resetActiveCustomization: () => setValue(undefined),
        activateColorChangeCustomization: () => setValue('color'),
        isColorChangeCustomizationActive: value === 'color',
        activateAliasChangeCustomization: () => setValue('alias'),
        isAliasChangeCustomizationActive: value === 'alias',
        activateAvatarChangeCustomization: () => setValue('avatar'),
        isAvatarChangeCustomizationActive: value === 'avatar',
    };
};
